//---------------------------------------------------------------//
// Accordions Features
//---------------------------------------------------------------//

// hide the all of the body elements by default
$('.accordion__item__body').hide();

// show panel body once its title is clicked and collapse up any other open body elements
$('.accordion__item__title').click(function () {
  $(this).toggleClass('open');
  $(this).next('.accordion__item__body').slideToggle(400);
  $(this)
    .closest('.accordion__item')
    .siblings()
    .children('.accordion__item__title')
    .removeClass('open')
    .next('.accordion__item__body')
    .slideUp(500);
  return false;
});
